import React, {Component} from 'react';
import API from "../../services/API";
class Slideshow extends Component {
    state = {
        slideShowPhotos: []
    };
    render() {
        return (
            <React.Fragment>
                <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner vh-50">
                        {
                            this.state.slideShowPhotos.map((slide,index) => {
                                const activeClass = index ?  "carousel-item" :  "carousel-item active";
                                return(
                                    <div key={index} className={activeClass +  " vh-50"}>
                                        <img src={slide.image} alt={slide.description} className="img-fluid vh-50" />
                                        <div className="carousel-caption w-100">
                                            <small>{slide.name}</small>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
    componentDidMount = () =>{
        API.getSlideshow('2')
            .then((response) => {
                this.setState({slideShowPhotos: response.results})
            })
    }
}

export default Slideshow;